/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Rag_Internal_Only_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "The AI may again use external sources and web search alongside your organisation's knowledge spaces." |
*
* @param {Audit_Details_Rag_Internal_Only_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_rag_internal_only_disabled_desc = /** @type {((inputs?: Audit_Details_Rag_Internal_Only_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Rag_Internal_Only_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI darf neben den verlinkten Wissensspaces Ihrer Organisation wieder externe Quellen und Websuche verwenden.")
	return /** @type {LocalizedString} */ ("The AI may again use external sources and web search alongside your organisation's knowledge spaces.")
});